import * as React from 'react';
import styled from 'styled-components';

export const AboutMeWrapper = styled('div')`
	display: flex;
	flex-direction: column;
`;
